import { FileTypeCopySink } from './file-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureBlobFSDataset } from 'app/model/dataset/azure-blob-fs.dataset';

@Metamodel.model({
    name: 'AzureBlobFSSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureBlobFSDataset) }
})
export class AzureBlobFSSink extends FileTypeCopySink {
    public static readonly MODEL: IModel;
}
